exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".usc-store.dt {\r\n    padding: 0px 25px;\r\n}\r\n\r\n.usc-store .legend {\r\n    text-align: center;\r\n}\r\n\r\n.usc-store .legend span {\r\n    font-weight: bold;\r\n}\r\n\r\n.usc-store .business-customer {\r\n    display: inline-block;\r\n    background-color: pink;\r\n    height: 40px;\r\n    border: 2px solid #004795;\r\n    padding: 9px;\r\n    font-weight: bold;\r\n    margin: 0px 20px;\r\n}\r\n\r\n.usc-store .late-for-appt {\r\n    display: inline-block;\r\n    background-color: pink;\r\n    height: 40px;\r\n    border: 2px solid #004795;\r\n    padding: 9px;\r\n    font-weight: bold;\r\n    margin: 0px 20px;\r\n}\r\n\r\n\r\n.usc-store .store-info {\r\n    text-align: center;\r\n    padding: 30px 0px 0px 0px;\r\n}\r\n\r\n.usc-store .store-info .name {\r\n    color: #004795;\r\n    font-weight: bold;\r\n    font-size: 25px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store-scheduling/usc-svt-appointments/usc-svt-appointments.component.css
// module id = ../../../../../src/app/components/usc-store-scheduling/usc-svt-appointments/usc-svt-appointments.component.css
// module chunks = main